<template>
    <div id="ag-grid-demo">
        <ag-grid-vue
                :gridOptions="gridOptions"
                class="ag-theme-material w-100 my-4 ag-grid-table"
                :columnDefs="columnDefs"
                :defaultColDef="defaultColDef"
                :rowData="dataTrx"
                rowSelection="multiple"
                colResizeDefault="shift"
                :animateRows="true"
                :floatingFilter="true"
                :pagination="true"
                :paginationPageSize="limit"
                :suppressPaginationPanel="true"
                :enableCellTextSelection="true"
        ></ag-grid-vue>
        <vs-pagination :total="totalPage" :max="maxPageNumbers" v-model="currentPage"/>
    </div>
</template>

<script>
    import {AgGridVue} from "ag-grid-vue"
    import moment from 'moment'
    import {url} from "@/configs/apiUrl"
    import Axios from "@/global/AxiosCall"
    import "@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss"
    import ActionTableAgGridComponent from "@/components/cell-render-component/ActionTableEditDeleteAgGridComponent"
    import StatusTableAgGridComponent from "@/components/cell-render-component/StatusTableAgGridComponentMerchant"
    import ActionTableShowSubmerchantAgGridComponent from "@/components/cell-render-component/merchant-management/ActionTableShowSubmerchant"

    export default {
        name: 'merchantList',
        props: {
            onFetchCallback: {type: Function},
        },
        components: {
            AgGridVue,
        },
        data() {
            return {
                searchQuery: "",
                gridOptions: {},
                maxPageNumbers: 7,
                gridApi: null,
                defaultColDef: {
                    sortable: true,
                    editable: false,
                    resizable: true,
                    suppressMenu: true,
                    // filterParams: {
                    //   applyButton: true,
                    //   newRowsAction: 'keep'
                    // },
                },
                columnDefs: [
                    {
                        headerName: "Merchant ID",
                        field: "id",
                        width: 150,
                        filter: true,
                        editable: false,
                    },
                    {
                        headerName: "Merchant Name",
                        field: "full_name",
                        width: 300,
                        filter: true,
                        editable: false,
                        pinned: "left"
                    },
                    {
                        headerName: "Has Submerchant",
                        field: "id",
                        filter: false,
                        editable: false,
                        cellRendererParams:{readShow:true},
                        cellStyle: {textAlign: "center"},
                        cellRendererFramework: ActionTableShowSubmerchantAgGridComponent,
                        width: 190
                    },
                    {
                        headerName: "Actions",
                        field: "id",
                        filter: false,
                        editable: false,
                        cellRendererParams:{readShow:false},
                        cellRendererFramework: ActionTableAgGridComponent,
                        width: 110
                    },
                    {
                        headerName: "Email",
                        field: "email",
                        filter: true,
                        editable: false,
                        width: 250
                    },
                    {
                        headerName: "AINO MID",
                        field: "code",
                        filter: true,
                        editable: false,
                        width: 180
                    },
                    {
                        headerName: "Merchant Category",
                        field: "merchant_categories",
                        filter: true,
                        editable: false,
                        width: 250
                    },
                    {
                        headerName: "Phone Number",
                        field: "phone",
                        filter: true,
                        editable: false,
                        width: 250
                    },
                    {
                        headerName: "Brand Name",
                        field: "brand_name",
                        filter: true,
                        editable: false,
                        width: 250
                    },
                    {
                        headerName: "Director Name",
                        field: "details.director_name",
                        filter: true,
                        editable: false,
                        width: 300
                    },
                    {
                        headerName: "Status",
                        field: "status",
                        filter: true,
                        editable: false,
                        width: 300,
                        cellRendererFramework: StatusTableAgGridComponent
                    },
                    {
                        headerName: "Registered Date",
                        field: "created_at",
                        filter: true,
                        editable: false,
                        width: 200,
                        cellRenderer:params=>{
                            if (params.value)
                                return moment(params.value).format("YYYY-MM-DD hh:mm:ss")
                            else
                                return '-'
                        }
                    },
                ],
                dataTrx: [],
                dataCount: 0,
                totalPage: 0,
                page: 1,
                limit: 20,
                totalData: 1,
            };
        },
        watch: {},
        computed: {
            currentPage: {
                get() {
                    if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
                    else return 1;
                },
                set(val) {
                    this.fetchData(val, this.limit);
                }
            }
        },
        methods: {
            //@filter-changed="onFilterModified"
            // onFilterModified(event){
            //   console.log("modified", JSON.stringify(event.api.getFilterModel()))
            //   console.log(Object.keys(event.api.getFilterModel()))
            //   this.dataTrx = []
            // },
            openLoading() {
              this.$vs.loading({
                type: "default"
              });
            },
            updateSearchQuery(val) {
                this.gridApi.setQuickFilter(val);
            },
            validateRoles() {
                const role = localStorage.getItem("userRole")
                return (role == 'root' || role == 'administrator')
            },
            fetchData(page, limit) {
                this.openLoading()
                let newPage = page;
                if (this.dataCount != 0) {
                    let totalPages = Math.ceil(this.dataCount / limit);
                    if (page > totalPages) {
                        newPage = totalPages;
                    }
                }

                Axios.Get(url.svd.merchant.account_info + "?page=" + newPage + "&limit=" + limit)
                    .then(resp => {
                        this.$vs.loading.close()
                        this.dataTrx = [];
                        if (resp.data.data.length != 0) {
                            this.totalData = parseInt(resp.data.total)
                            let no = ((page-1)*limit) + 1;
                            for (let data of resp.data.data) {
                                data.no = no;
                                data.submerchant_count = parseInt(data.submerchant_count);
                                this.dataTrx.push(data);
                                no++;
                            }

                            this.dataCount = resp.data.total;
                            this.page = page;
                            if (limit >= this.dataCount) {
                                this.limit = this.dataTrx.length;
                            } else {
                                this.limit = limit;
                            }

                            this.gridApi.paginationSetPageSize(this.limit);
                            this.totalPage = resp.data.lastPage;

                            const payload = {
                                totalPage: this.totalPage,
                                totalData: this.totalData,
                                page: this.page,
                                limit: this.limit,
                                dataCount: this.dataCount,
                                gridApi: this.gridApi,
                                event: 'merchant-list'
                            }

                            this.onFetchCallback(payload)
                        }
                    })
                    .catch(e => {
                        this.$vs.loading.close()
                        console.log(e);
                    });
            },
            editRecord(value) {
                if (value.parent_id !== 0) {
                    this.$router.push({
                        name: "merchantEdit",
                        params: {
                            id: value.id
                        }
                    });
                } else {
                    this.$router.push({
                        name: "merchantEdit",
                        params: {
                            id: value.id
                        }
                    });
                }
            },
            readRecord(value) {

                    this.$router.push({
                        name: "subMerchantList",
                        params: {
                            id: value.id
                        }
                    });

            },
            treeRecord(value) {

                this.$router.push({
                    name: "treeMerchant",
                    params: {
                        id: value.id
                    }
                });

            },
            configureRecord(value) {
                this.$router.push({
                    name: "MerchantConfiguration",
                    params: {
                        id: value
                    }
                });
            },
            deleteRecord(data) {
                let root = this;
                this.$vs.dialog({
                    type: "confirm",
                    color: "primary",
                    title: `Confirm`,
                    text: "Are you sure deleted this record ?",
                    accept: () => {
                        Axios.Delete(url.svd.merchant.account_info + "/" + data)
                            .then(resp => {
                                if (resp.data === true) {
                                    root.fetchData(root.page, root.limit);
                                    this.$vs.notify({
                                        title: "Success",
                                        text: "You successfully deleted!",
                                        iconPack: "feather",
                                        icon: "icon-check-square",
                                        color: "success",
                                        position: "top-right"
                                    });
                                }
                            })
                            .catch(e => {
                                console.log(e);
                                this.$vs.notify({
                                    title: "Failed",
                                    text: "Network failed!",
                                    iconPack: "feather",
                                    icon: "icon-alert-circle",
                                    color: "danger",
                                    position: "top-right"
                                });
                            });
                    }
                });
            }
        },
        beforeMount() {
            /*const role = localStorage.getItem("userRole")
            if (!(role == 'root' || role == 'administrator')) {
                console.log(this.columnDefs)
                this.$delete(this.columnDefs, this.columnDefs.length - 1)
            }*/
        },
        created() {
          let userInfo = JSON.parse(localStorage.getItem("userInfo"))
          if (userInfo.role !== "root" && userInfo.role !== "administrator" && userInfo.role !== "aino_cc") {
            this.columnDefs[2].hide = true
          }
        },
        mounted() {
            this.gridApi = this.gridOptions.api;

            this.gridOptions.getRowStyle = function(params) {
                if (params.node.rowIndex % 2 === 0) {
                    return { background: '#f9f9f9' }
                }
            }
            this.gridOptions.rowHeight = 42;

            this.$root.$on("delete-from-ActionTableAgGridComponent", data => {
                this.deleteRecord(data);
            });

            this.$root.$on("edit-from-ActionTableAgGridComponent", data => {
                this.editRecord(data);
            });

            this.$root.$on("read-from-ActionTableAgGridComponent", data => {
                this.readRecord(data);
            });

            this.$root.$on("tree-from-ActionTableAgGridComponent", data => {
                this.treeRecord(data);
            });

            this.$root.$on("configure-from-ActionTableAgGridComponent", data => {
                this.configureRecord(data);
            });

            this.$root.$on("merchant-list", data => {
                this.fetchData(data.page, data.limit);
            })

            let pagination_prev = document.getElementsByClassName("btn-prev-pagination")
            pagination_prev[0].id="btn-pagination-list-prev"
            let pagination_next = document.getElementsByClassName("btn-next-pagination")
            pagination_next[0].id="btn-pagination-list-next"
        }
    };
</script>